import { ListSelectionStyled, SubListSelectionStyled } from '@bechtel/client-common';
import { Box, Checkbox, Text } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { FieldArray, FieldProps } from 'formik';
import { findIndex, map, some } from 'lodash';
import React, { Fragment } from 'react';
import { unassignedList } from './mock';

export const UnassignedList: React.FC<FieldProps> = ({ form }) => {
  const { i18n } = useLingui();
  return (
    <Fragment>
      <Box data-testid="success" flexDirection={{ sm: 'column' }}>
        <SubListSelectionStyled
          onClick={() => {
            if (form.values.filterByUnassignedPersona?.length !== unassignedList.length) {
              form.setFieldValue(
                'filterByUnassignedPersona',
                map(unassignedList, (flag) => flag.value)
              );
            } else {
              form.setFieldValue('filterByUnassignedPersona', []);
            }
          }}
        >
          <Box alignItems={{ sm: 'center' }}>
            <Box mr={{ sm: '500' }}>
              <Checkbox
                checked={form.values.filterByUnassignedPersona?.length === unassignedList.length}
                readOnly
                indeterminate={
                  form.values.filterByUnassignedPersona?.length > 0 &&
                  form.values.filterByUnassignedPersona?.length < unassignedList.length
                }
              />
            </Box>
            <Text size="400" weight="600" color="bechtel.grey.1000">
              <Trans>Unassigned</Trans>
            </Text>
          </Box>
          {form.values.filterByUnassignedPersona && form.values.filterByUnassignedPersona.length > 0 && (
            <Text size="400" color="bechtel.grey.1000">
              {form.values.filterByUnassignedPersona.length} <Trans>Selected</Trans>
            </Text>
          )}
        </SubListSelectionStyled>
        <FieldArray name="filterByUnassignedPersona">
          {(arrayHelpers) => {
            return (
              <>
                {unassignedList &&
                  unassignedList.map((unassignedItem) => {
                    return (
                      <ListSelectionStyled
                        key={unassignedItem.value}
                        data-testid={`planning-wp-search-unassigned-${unassignedItem.id}`}
                        onClick={() => {
                          const selected = findIndex(form.values.filterByUnassignedPersona, (item) => {
                            return item === unassignedItem.value;
                          });
                          if (selected !== -1) {
                            arrayHelpers.remove(selected);
                          } else {
                            arrayHelpers.push(unassignedItem.value);
                          }
                        }}
                      >
                        <Box mr={{ sm: '500' }}>
                          <Checkbox
                            checked={some(form.values.filterByUnassignedPersona, (item) => {
                              return item === unassignedItem.value;
                            })}
                            readOnly
                          />
                        </Box>
                        {unassignedItem?.label && (
                          <Text size="400" color="bechtel.grey.1000">
                            {i18n._(unassignedItem?.label)}
                          </Text>
                        )}
                      </ListSelectionStyled>
                    );
                  })}
              </>
            );
          }}
        </FieldArray>
      </Box>
    </Fragment>
  );
};
